module.exports = __webpack_public_path__ + "static/media/edit_pen.6baf239a.svg";